import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Input, ViewChild, inject } from '@angular/core';

@Component({
  selector: 'app-info-tooltip',
  templateUrl: './info-tooltip.component.html',
  styleUrl: './info-tooltip.component.css',
  imports: [CommonModule],
})
export class InfoTooltipComponent {
  @Input() text = '';
  @Input() position: 'left' | 'right' = 'right';

  private elementRef = inject(ElementRef);
  // Con il mouse si apre al passaggio; su touch resta il tocco
  private canHover = typeof window !== 'undefined' && !!window.matchMedia?.('(hover: hover)').matches;
  open = false;
  /** Spostamento orizzontale per tenere il riquadro dentro lo schermo. */
  shiftX = 0;

  @ViewChild('popover') set popover(ref: ElementRef<HTMLElement> | undefined) {
    if (ref) requestAnimationFrame(() => this.fitInViewport(ref.nativeElement));
  }

  toggle(event: MouseEvent) {
    event.stopPropagation();
    if (this.canHover && this.open) return;
    this.shiftX = 0;
    this.open = !this.open;
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    if (!this.canHover) return;
    this.shiftX = 0;
    this.open = true;
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (this.canHover) this.open = false;
  }

  private fitInViewport(el: HTMLElement) {
    const margin = 12;
    const rect = el.getBoundingClientRect();
    const left = rect.left - this.shiftX;
    const right = rect.right - this.shiftX;
    if (right > window.innerWidth - margin) this.shiftX = window.innerWidth - margin - right;
    else if (left < margin) this.shiftX = margin - left;
    else this.shiftX = 0;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.open && !this.elementRef.nativeElement.contains(event.target)) {
      this.open = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    this.open = false;
  }
}
